import { createSelector } from 'reselect';
import { RootState } from 'store';
import adapter from './attachments.adapter';
import { REDUCER_KEY } from './attachments.consts';
import { AttachmentParams } from './attachments.types';
import { selectCurrentProposal } from 'store/proposals';

const selectors = adapter.getSelectors(
  (state: RootState) => state[REDUCER_KEY],
);
export const { selectIds, selectTotal, selectAll } = selectors;

export const selectById = (
  state: RootState,
  id: number,
): AttachmentParams | null => selectors.selectById(state, id) || null;

export const selectAllAttachments = createSelector(
  state => selectors.selectAll(state),
  attachments => attachments || [],
);

export const selectAttachmentsOfCurrentProposal = createSelector(
  selectCurrentProposal,
  selectAllAttachments,
  (currentProposal, attachments) =>
    attachments.filter(({ proposalId }) => proposalId === currentProposal?.id),
);

export function selectAttachment(
  state: RootState,
  attachmentId: number,
): AttachmentParams | undefined {
  return selectors.selectById(state, attachmentId) || undefined;
}
